import styled from 'styled-components';

interface VisibilityProps {
  visible: boolean;
}

const Visibility = styled.div<VisibilityProps>`
  visibility: ${(props) => (props.visible ? null : 'hidden')};
`;

export const Displayable = styled.div<VisibilityProps>`
  display: ${(props) => (props.visible ? null : 'none')};
`;

export default Visibility;
